// Utilidades para manejo de zonas horarias en la aplicación

/**
 * Obtiene la hora actual en la zona horaria de Argentina
 * @returns {Date} Fecha y hora actual en Argentina
 */
export const getCurrentTimeArgentina = () => {
  const now = new Date();
  return new Date(now.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" }));
};

/**
 * Convierte una fecha UTC a hora de Argentina
 * @param {Date|string} utcDate - Fecha en UTC
 * @returns {Date} Fecha convertida a hora de Argentina
 */
export const convertUTCToArgentina = (utcDate) => {
  const date = new Date(utcDate);
  return new Date(date.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" }));
};

/**
 * Formatea una fecha para mostrar en formato legible en Argentina
 * @param {Date|string} date - Fecha a formatear
 * @param {boolean} includeTime - Si incluir la hora
 * @returns {string} Fecha formateada
 */
export const formatDateArgentina = (date, includeTime = true) => {
  const argentinaDate = convertUTCToArgentina(date);
  
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'America/Argentina/Buenos_Aires'
  };
  
  if (includeTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
    options.second = '2-digit';
  }
  
  return argentinaDate.toLocaleString('es-AR', options);
};

/**
 * Obtiene la diferencia horaria entre UTC y Argentina
 * @returns {number} Diferencia en horas
 */
export const getArgentinaTimeOffset = () => {
  const utc = new Date();
  const argentina = new Date(utc.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" }));
  return (argentina.getTime() - utc.getTime()) / (1000 * 60 * 60);
};

/**
 * Crea una fecha ISO string en la zona horaria de Argentina
 * @returns {string} ISO string en hora de Argentina
 */
export const getArgentinaISOString = () => {
  const now = new Date();
  const argentinaTime = new Date(now.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" }));
  
  // Crear un ISO string que represente la hora de Argentina
  const offset = getArgentinaTimeOffset();
  const argentinaDate = new Date(now.getTime() + (offset * 60 * 60 * 1000));
  
  return argentinaDate.toISOString();
};

/**
 * Verifica si es horario de verano en Argentina
 * @returns {boolean} True si es horario de verano
 */
export const isArgentinaDST = () => {
  const now = new Date();
  const jan = new Date(now.getFullYear(), 0, 1);
  const jul = new Date(now.getFullYear(), 6, 1);
  
  const janOffset = new Date(jan.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })).getTimezoneOffset();
  const julOffset = new Date(jul.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })).getTimezoneOffset();
  const currentOffset = new Date(now.toLocaleString("en-US", { timeZone: "America/Argentina/Buenos_Aires" })).getTimezoneOffset();
  
  return Math.min(janOffset, julOffset) === currentOffset;
};

// Función para mostrar información de zona horaria (útil para debugging)
export const logTimezoneInfo = () => {
  console.log('🌍 Información de Zona Horaria:');
  console.log('Hora UTC:', new Date().toISOString());
  console.log('Hora Argentina:', getCurrentTimeArgentina());
  console.log('Diferencia horaria:', getArgentinaTimeOffset(), 'horas');
  console.log('Es horario de verano:', isArgentinaDST());
  console.log('ISO String Argentina:', getArgentinaISOString());
}; 